import { NgRedux } from '@redux/redux-compatibility.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CatPhraseSubType } from 'src/app/shared/models/cat.model';
import { AppState } from 'src/app/shared/redux/store';
import { CatService } from 'src/app/shared/services/cat.service';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'edit-phrase-sub-type',
    templateUrl: './edit-phrase-sub-type.component.html',
    styleUrls: ['./edit-phrase-sub-type.component.scss'],
    standalone: false
})
export class EditPhraseSubTypeComponent implements OnInit {
  @Input() subType: CatPhraseSubType;
  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();
  loading: boolean;
  isNew: boolean;

  get modalTitle(): string {
    if (this.isNew) return 'translate.cat.mngPhraseTypeAddSubType';
    else return 'translate.cat.mngPhraseTypeEditSubType';
  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private sharedService: SharedService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.isNew = this.subType.subTypeCode == null;
    this.subType.saveOriginal();
  }

  isDirty(): boolean {
    return this.subType.isDirty();
  }

  close() {
    if (this.isDirty()) {
      let validationStr = this.translateService.instant(
        'translate.cat.discardEditChanges'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.discardChanges();
          this.onClose.emit();
        },
      });
    } else {
      this.onClose.emit();
    }
  }

  discardChanges() {
    this.subType.restoreOriginal();
  }

  validateBeforeSave(): boolean {
    if (!this.subType.subTypeCode || !this.subType.subTypeDescr) {
      return false;
    } else {
      return true;
    }
  }

  saveChanges() {
    this.loading = true;
    this.catService
      .updCatPhraseSubType(this.subType, this.isNew ? 'ADD' : 'UPD')
      .subscribe(
        (data) => {
          this.loading = false;
          this.onSave.emit();
        },
        (err) => (this.loading = false)
      );
  }

  onDeleteClicked() {
    let validationStr = this.translateService.instant(
      'translate.cat.deletePhraseType'
    );

    this.sharedService.emitPopupchReceivedEvent({
      title: 'translate.validation.confirm',
      icon: 'exclamation-triangle',
      subTitle: validationStr,
      keep: false,
      approve: () => {
        this.loading = true;
        this.catService.updCatPhraseSubType(this.subType, 'DEL').subscribe(
          (data) => {
            this.loading = false;
            this.onSave.emit();
          },
          (err) => (this.loading = false)
        );
      },
    });
  }
}
